(function () {
    /** add file size to validation */
    $.validator.addMethod("filesize",
        function (value, element, params) {
            var item = element;
            if (item.files.length < 1) {
                /** no files selected */
                return true;
            }
            if (!item.files || !item.files[0].size) {
                /** browser doesn't support the HTML5 API */
                return true;
            }
            return item.files[0].size < params;
        },
        "");

    /** add file size to unobtrusive adapter */
    $.validator.unobtrusive.adapters.add("filesize",
        ["maxsize"],
        function (options) {
            options.rules["filesize"] = options.params["maxsize"];
            options.messages["filesize"] = options.message;
        });

    /** add allowed file extensions to validation */
    $.validator.addMethod("allowedfileextensions",
        function (value, element, params) {
            var item = element;
            if (item.files.length < 1) {
                /** no files selected */
                return true;
            }
            if (!item.files || !item.files[0].name) {
                /** browser doesn't support the HTML5 API */
                return true;
            }
            var result = true;
            var extensions = (/[.]/.exec(value)) ? /[^.]+$/.exec(value) : undefined;
            if (extensions !== undefined) {
                var extension = extensions[0];
                result = $.inArray(extension.toLowerCase(), params.extensions) !== -1;
            }
            return result;
        },
        "");

    /** add allowed file extensions to unobtrusive adapter */
    $.validator.unobtrusive.adapters.add("allowedfileextensions",
        ["extensions"],
        function (options) {
            options.rules["allowedfileextensions"] = { extensions: options.params.extensions.split(",") };
            options.messages["allowedfileextensions"] = options.message;
        });

    /** Change decimal seperator to ,*/
    $.validator.methods.number = function (value, element) {
        return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:\.\d{3})+)?(?:,\d+)?$/.test(value);
    }

    /** add required if extensions to validation */
    $.validator.addMethod("requiredif", function (value, element, parameters) {
        const dependentproperty = parameters.dependentproperty;
        let dependentvalue = JSON.parse(parameters.dependentvalue);

        const controlType = $(`input[name$='${dependentproperty}']`).attr("type");
        let actualvalue = {};

        if (controlType === "checkbox" || controlType === "radio") {
            const control = $(`input[name$='${dependentproperty}']:checked`);
            actualvalue = control.val();
        } else
            actualvalue = $(`#${dependentproperty}`).val();

        for (let item of dependentvalue) {
            if ($.trim(item.toString()).toLowerCase() === $.trim(actualvalue).toLocaleLowerCase()) {
                const isValid = $.validator.methods.required.call(this, value, element, parameters);
                return isValid;
            }
        }

        return true;
    });

    /** add required if to unobtrusive adapter */
    $.validator.unobtrusive.adapters.add("requiredif", ["dependentproperty", "dependentvalue"], function (options) {
        options.rules["requiredif"] = options.params;
        options.messages["requiredif"] = options.message;
    });
})();
